import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { TResponseRateType } from '../../types/responseRateType';

import * as styles from './AboutRealtorMobile.css';

interface IAboutRealtorMobileProps {
  responseRateType: TResponseRateType | null;
  generalInfo: JSX.Element;
  chatStatistics: JSX.Element;
  photo: JSX.Element;
  rate: JSX.Element;
  additionalInfo: JSX.Element;
  className?: string;
}

export const AboutRealtorMobile: React.FunctionComponent<React.PropsWithChildren<IAboutRealtorMobileProps>> = props => {
  const { responseRateType, generalInfo, chatStatistics, photo, rate, additionalInfo, className } = props;

  return (
    <div
      {...mergeStyles(
        styles['container'],
        responseRateType === 'high' ? styles['container_high_rate'] : '',
        responseRateType === 'low' ? styles['container_low_rate'] : '',
        className,
      )}
    >
      <div className={styles['columns']}>
        <div className={styles['left_column']}>
          <div className={styles['general_info']}>{generalInfo}</div>
          {chatStatistics}
        </div>
        <div className={styles['right_column']}>
          {photo}
          <div className={styles['rate']}>{rate}</div>
        </div>
      </div>
      {additionalInfo}
    </div>
  );
};

AboutRealtorMobile.displayName = 'AboutRealtorMobile';
